import React from "react";
import { useTheme } from "../../../context/ThemeContext";
import { Link } from "react-router-dom";

const Hero = () => {
  const { theme } = useTheme();
  const myimg = theme === "light" ? "webdev-light.png" : "webdev-dark.png";
  return (
    <section className="relative pt-32 pb-16 px-6 lg:px-20 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-colors duration-300">
      {/* BACKGROUND EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID OVERLAY */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:70px_70px]" />

      <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-12 max-w-7xl mx-auto">
        {/* LEFT CONTENT */}
        <div className="flex-1 space-y-6">
          <span className="text-orange-500 font-semibold tracking-wide uppercase text-sm">
            Gethat Services
          </span>
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 dark:text-white leading-tight">
            Advanced Website Development Solutions
          </h1>
          <p className="text-gray-600 dark:text-gray-300 text-lg max-w-lg">
            Transform your digital presence with high-performance web solutions.
            We blend innovative design with robust development to help your
            business scale and succeed.
          </p>
          <Link
            to="https://webxsecure.in/contact"
            className="bg-primary inline-flex text-white px-8 py-3 rounded-lg font-medium hover:bg-primary transition-all shadow-lg hover:shadow-orange-500/30"
          >
            Get Started
          </Link>
        </div>

        {/* RIGHT COMPLEX DASHBOARD IMAGE */}
        <div className="flex-1 w-full max-w-2xl">
          {/* Image representing the dashboard/IDE from your reference */}
          <img
            src={myimg}
            alt="Development Dashboard"
            className="w-full h-auto rounded-xl shadow-inner "
          />
          {/* Optional: Add a subtle overlay gradient to make it look more like a UI screenshot */}
          <div className="absolute inset-0 bg-gradient-to-tr from-orange-500/5 to-transparent rounded-2xl pointer-events-none" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
